<mat-toolbar class="top-navbar mat-elevation-z2" fxLayoutAlign="center center">
  <a mat-button routerLink="/" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">Главная</a>
  <a mat-button [matMenuTriggerFor]="menu" (click)="openMegaMenu()">Категории<mat-icon class="caret">arrow_drop_down</mat-icon></a>
  <mat-menu #menu="matMenu" [overlapTrigger]="false" class="mega-menu app-dropdown">
    <div *ngIf="categories" fxLayout="row wrap">
      <div *ngFor="let category of categories" fxFlex="20" fxLayout="column" class="p-1">
        <div mat-menu-item>
          <b>{{category.vName}}</b>
        </div>
        <mat-divider></mat-divider>
        <div *ngIf="category?.subCategories">
          <div *ngFor="let subCategory of category?.subCategories">
            <a mat-menu-item [routerLink]="['/products', subCategory.id, subCategory.vName]">{{subCategory.vName}}</a>
          </div>
        </div>
      </div>

    </div>

  </mat-menu>

  <!--<a mat-button [routerLink]="['/products', 'jewellery']" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">О магазине</a>-->
  <a mat-button routerLink="/about-us" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">О магазине</a>
  <a mat-button routerLink="/news" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">Новости</a>
  <a mat-button routerLink="/contact" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">Контакты</a>

</mat-toolbar>

